import React from 'react';
import { List, Typography } from 'antd';

const { Text } = Typography;

const RankingList = ({ title, list = [] }) => {
  // Generate sample data if none provided
  const rankingData = list.length > 0 ? list : [
    { name: "Village 1 Number shop", total: 1234.56 },
    { name: "Village 2 Number shop", total: 1134.56 },
    { name: "Village 3 Number shop", total: 1034.56 },
    { name: "Village 4 Number shop", total: 934.56 },
    { name: "Village 5 Number shop", total: 834.56 },
    { name: "Village 6 Number shop", total: 734.56 },
    { name: "Village 7 Number shop", total: 634.56 },
    { name: "Village 8 Number shop", total: 534.56 }
  ];

  return (
    <div>
      {title && <h4 style={{ marginBottom: '16px' }}>{title}</h4>}
      <List
        dataSource={rankingData}
        renderItem={(item, index) => (
          <List.Item>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span style={{ 
                  width: '20px', 
                  height: '20px', 
                  borderRadius: '50%', 
                  backgroundColor: index < 3 ? '#1890ff' : '#f0f0f0',
                  color: index < 3 ? 'white' : '#666',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  marginRight: '8px'
                }}>
                  {index + 1}
                </span>
                <Text>{item.name}</Text>
              </div>
              <Text strong>${item.total.toFixed(2)}</Text>
            </div>
          </List.Item>
        )}
      />
    </div>
  );
};

export default RankingList;
